import './App.css';
import './css/active-tasks.css';
import LoginForm from './pages/login/LoginForm';
import Logout from './pages/logout/Logout';
import Button from './components/Button';
import AuthContext from './providers/AuthContext';
import DetailsContext from './providers/DetailsContext';
import { BrowserRouter as Router, Routes, Route , useLocation, useNavigate } from 'react-router-dom';
import Clients from './pages/klienci/Index';
import Settings from './pages/settings/Index';
import BackgroundHealth from './pages/background-health/Index';
import VocabularyConfig from './pages/vocabulary-config/Index';
import AiConfig from './pages/ai-config/Index';
import QuizGenerationConfig from './pages/quiz-generation-config/Index';
import DbBackups from './pages/db-backups/Index';
import axios from 'axios';
import { useEffect, useState } from 'react';
import language from './variables/language';
import { seedDefaultThemeLocalStorage } from './variables/themeColorKeys';
import Users from './pages/users/Index';
import Pipeline from './pages/pipeline/Index';
import Schedule from './pages/schedule/Index';
import Dashboard from './pages/dashboard/Index';
import Cars from './pages/students/Index';
import Projects from './pages/projekts/Index';
import Card from './pages/klienci/Card';
import CarDocuments from './pages/students/StudentDocuments';
import Students from './pages/students/Index';
import Conversations from './pages/conversations/Index';
import Answers from './pages/conversations/Answers';
import Messages from './pages/conv-progress/Messages';
import StudentCard from './pages/students/StudentCard';
import Groups from './pages/groups/Index';
import GroupCard from './pages/groups/GroupCard';
import GroupCourseWorkspaceView from './pages/groups/workspace/GroupCourseWorkspaceView';
import Games from './pages/games/Index';
import GameCard from './pages/games/GameCard';
import GameSetCard from './pages/games/GameSetCard';
import IndexConversationProgress from './pages/conv-progress/Index';
import wsManager from "./services/wsManager";
import PipelineCreator from './pages/pipeline-creator/Index';
import ConversationCreatorCanvas from './pages/conversations-creator-canvas/Index';
import ConversationMainView from './pages/converations-menu/Index';
import ConversationListView from './pages/converations-menu/ConversationListView';
import ConversationsAiGenerator from './pages/conversations-ai-generator/Index';
import ConversationsBotHealth from './pages/conversations-bot-health/Index';
import ExerciseTemplates from './pages/exercise-templates/Index';
import ExerciseTemplateBuilder from './pages/exercise-templates/Builder';
import Communications from './pages/communications/Index';
import CommunicationBuilder from './pages/communications/Builder';
import Courses from './pages/courses/Index';
import CourseWorkspace from './pages/courses/Workspace';
import StudentWorkspaceView from './pages/students/workspace/StudentWorkspaceView';
import TopicCanvasView from './pages/students/workspace/TopicCanvasView';
import HomeworkPreview from './pages/students/workspace/HomeworkPreview';
import PendingApprovalsProvider from './providers/PendingApprovalsProvider';
import ActiveTasksProvider from './providers/ActiveTasksProvider';
import ActiveTasksTray from './components/tasks/ActiveTasksTray';
import TaskToastStack from './components/tasks/TaskToastStack';

function App() {
  const API_URL = process.env.REACT_APP_API_URL;
  const [lang,setLang] = useState("ua");
  language.lang = lang;
  const dtf = new Intl.DateTimeFormat();
  const [timeZone,setTimeZone] = useState(dtf.resolvedOptions().timeZone);
  const [authChecked, setAuthChecked] = useState(false);
  const browserLanguage = navigator.language || navigator.userLanguage;
 

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [userId, setUserId] = useState('');
  const [theme, setTheme] = useState(localStorage.getItem("theme")===null?true:localStorage.getItem("theme"));


  const navigate = useNavigate();
  const location = useLocation();


  //initialization bar 
  if(localStorage.getItem("nav-bar-open")===null){
    localStorage.setItem("nav-bar-open",true);
  }
  seedDefaultThemeLocalStorage();
  

  useEffect(() => {
      axios.get('/api/islogin', {
        withCredentials: true,
      })
      .then(response => { 
        setUserId(response.data.id);
        setIsLoggedIn(true);
        setFirstName(response.data.imie);
        setLastName(response.data.nazwisko);
        wsManager.connect(window.location.origin);
      })
      .catch(() => {
        setIsLoggedIn(false);
      })
      .finally(() => {
        setAuthChecked(true);
      });
   }, [isLoggedIn, navigate, API_URL, location.pathname]);


  if (!authChecked) {
    return <div>Loading...</div>;
  }
  return (
    <div className="App" >

      {!isLoggedIn ? (
            <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn, firstName, setFirstName,
              lastName, setLastName, userId, setUserId ,timeZone , setTimeZone }}>
              <DetailsContext.Provider value={{ theme, setTheme, lang, setLang  }}>
                  <Routes>
                    <Route path="/login" element={<LoginForm />} />
                    <Route path="*" element={<LoginForm />} />
                  </Routes>
              </DetailsContext.Provider>
            </AuthContext.Provider>
              ) : (
        <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn, firstName, setFirstName,
           lastName, setLastName, userId, setUserId ,timeZone , setTimeZone }}>
          <DetailsContext.Provider value={{ theme, setTheme, lang, setLang  }}>
           <PendingApprovalsProvider>
            <ActiveTasksProvider>
              <ActiveTasksTray/>
              <TaskToastStack/>
              <Routes >
                <Route index  element={<Dashboard />}/>
                <Route path='/dashboard' element={<Dashboard/>}/>
                <Route path='/games' element={<Games/>}/>
                <Route path='/games/sets/:id' element={<GameSetCard/>}/>
                <Route path='/games/:id' element={<GameCard/>}/>
                <Route path='/exercise-templates' element={<ExerciseTemplates/>}/>
                <Route path='/communications' element={<Communications/>}/>
                <Route path='/communications/:id' element={<CommunicationBuilder/>}/>
                <Route path='/exercise-templates/:id' element={<ExerciseTemplateBuilder/>}/>
                <Route path='/courses' element={<Courses/>}/>
                <Route path='/courses/:id' element={<CourseWorkspace/>}/>
                <Route path='/clients' element={<Clients/>}/>
                <Route path='/clients/:id' element={<Card/>}/>
                
                <Route path='/pipeline' element={<Pipeline/>}/>
                <Route path='/pipeline/:id' element={<Pipeline/>}/>
                <Route path='/pipeline-creator/:id' element={<PipelineCreator/>}/>
                <Route path='/schedule' element={<Schedule/>}/>
                <Route path='/projects' element={<Projects/>}/>
                <Route path='/users' element={<Users/>}/>
                <Route path='/students' element={<Students/>}/>
                <Route path='/groups' element={<Groups/>}/>
                <Route path='/groups/:id' element={<GroupCard/>}/>
                <Route path='/groups/:groupId/workspace/:courseId' element={<GroupCourseWorkspaceView/>}/>
                <Route path='/students/:id' element={<StudentCard/>}/>
                <Route path='/students/:studentId/workspace/:courseId' element={<StudentWorkspaceView/>}/>
                <Route path='/students/:studentId/workspace/:courseId/canvas/:topicId' element={<TopicCanvasView/>}/>
                <Route path='/students/:studentId/homework/:exerciseId' element={<HomeworkPreview/>}/>

                <Route path='/cardocuments/bycar/:id' element={<CarDocuments/>}/>
                <Route path='/conversations' element={<Conversations/>}/>
                <Route path='/conversations-new' element={<ConversationListView/>}/>
                <Route path='/conversations-menu' element={<ConversationMainView/>}/>
                <Route path='/conversations-ai-generator' element={<ConversationsAiGenerator/>}/>
                <Route path='/conversations-bot-health' element={<ConversationsBotHealth/>}/>
                <Route path='/conversations-creator-canvas/:id' element={<ConversationCreatorCanvas/>}/>
                <Route path='/conversations/:id' element={<Answers/>}/>



                <Route path='/messages/byconvprogress/:id' element={<Messages/>}/>
                <Route path='/conversationprogress' element={<IndexConversationProgress/>}/>
                <Route path='/login' element={<LoginForm />}/>
                <Route path='/logout' element={<Logout />}/>
                <Route path='/settings' element={<Settings />}/>
                <Route path='/background-health' element={<BackgroundHealth />}/>
                <Route path='/vocabulary-config' element={<VocabularyConfig />}/>
                <Route path='/ai-config' element={<AiConfig />}/>
                <Route path='/quiz-generation-config' element={<QuizGenerationConfig />}/>
                <Route path='/db-backups' element={<DbBackups />}/>
              </Routes>
            </ActiveTasksProvider>
           </PendingApprovalsProvider>
          </DetailsContext.Provider>
        </AuthContext.Provider>
        )
      }
    </div>
  );
}

export default App;
